"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsProxyEndpoints = exports.getEventProxyHost = exports.EVENT_PROXY_PRODUCTION_HOST = exports.EVENT_PROXY_STAGING_HOST = exports.EVENT_PROXY_DEVELOPMENT_HOST = exports.EVENT_PROXY_LOCAL_HOST = void 0;
const types_1 = require("../types");
exports.EVENT_PROXY_LOCAL_HOST = 'http://localhost:4242';
exports.EVENT_PROXY_DEVELOPMENT_HOST = 'https://donny.wetransferalpha.net';
exports.EVENT_PROXY_STAGING_HOST = 'https://donny.wetransferbeta.com';
exports.EVENT_PROXY_PRODUCTION_HOST = 'https://donny.wetransfer.com';
const getEventProxyHost = (environmentName) => {
    const envToProxyUrlMap = {
        [types_1.EnvironmentName.Local]: exports.EVENT_PROXY_LOCAL_HOST,
        [types_1.EnvironmentName.Development]: exports.EVENT_PROXY_DEVELOPMENT_HOST,
        [types_1.EnvironmentName.Staging]: exports.EVENT_PROXY_STAGING_HOST,
        [types_1.EnvironmentName.Production]: exports.EVENT_PROXY_PRODUCTION_HOST,
    };
    const url = envToProxyUrlMap[environmentName];
    if (!url) {
        throw new Error(`No proxy url found for environment ${environmentName}`);
    }
    return url;
};
exports.getEventProxyHost = getEventProxyHost;
exports.EventsProxyEndpoints = {
    endpoints: {
        impresion: '/i.gif',
        customEvent: '/e.gif',
    },
};
//# sourceMappingURL=event.config.js.map